import { useEffect, useState } from 'react';

export function createGlobalState<State>(initialState: State) {
  const store = {
    state: initialState,
    setState(nextState: State) {
      store.state = nextState;
      store.setterList.forEach(setter => setter(nextState));
    },
    setterList: [] as ((state: State) => void)[],
  };

  return (): [State, (value: State) => void] => {
    const [globalState, stateSetter] = useState<State>(store.state);

    useEffect(() => {
      let mounted = true;
      store.setterList.push((state: State) => {
        if (mounted) {
          stateSetter(state);
        }
      });

      return () => {
        mounted = false;
        store.setterList = store.setterList.filter(x => x !== stateSetter);
      };
    }, []);

    return [globalState, store.setState];
  };
}
